import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { HelpHint } from "@/components/HelpHint";

// Settings -> Office Contact tab. Extracted from Settings.js (props-driven,
// no behavior change).
export const OfficeContactSection = ({ officeContact, onChange, onSave, saving }) => (
  <>
    <div className="flex items-center gap-1.5">
      <h2 className="font-heading text-lg font-semibold">Office Contact</h2>
      <HelpHint text="Shown on classroom reminders and payment-hold messages so families know who to call." testId="office-contact-help" />
    </div>
    <div className="grid sm:grid-cols-2 gap-3 max-w-md">
      <div className="space-y-1.5">
        <Label>Phone</Label>
        <Input value={officeContact.phone || ""} onChange={(e) => onChange({ ...officeContact, phone: e.target.value })} data-testid="office-contact-phone-input" />
      </div>
      <div className="space-y-1.5">
        <Label>Email</Label>
        <Input value={officeContact.email || ""} onChange={(e) => onChange({ ...officeContact, email: e.target.value })} data-testid="office-contact-email-input" />
      </div>
    </div>
    <div className="pt-2 border-t">
      <Button onClick={onSave} disabled={saving} className="bg-[hsl(var(--role-accent))] hover:opacity-95" data-testid="office-contact-save-button">
        {saving ? "Saving..." : "Save Changes"}
      </Button>
    </div>
  </>
);
